<template>
  <dialogBar @on-close="close" v-if="config.show" :dialog-width="config.width">
    <div slot="header">{{ config.title }}</div>
    <div class="dialog_publish_main" slot="main">
      <el-form
        ref="form"
        :model="config.data"
        :rules="rules"
        label-width="80px"
      >
        <el-form-item label="角色名称" prop="name">
          <el-input size="mini" v-model.trim="config.data.name"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="info" size="mini" @click="close(false)">取消</el-button>
      <el-button type="primary" size="mini" @click="onSubmit()">确认</el-button>
    </div>
  </dialogBar>
</template>
<script>
import dialogBar from "./comment/dialogBar";

export default {
  components: {
    dialogBar: dialogBar,
  },
  props: {
    config: {
      type: Object,
      default: {
        show: false,
        width: 800,
        title: "",
        data: {},
      },
    },
  },
  data() {
    var validateName = (rule, value, callback) => {
      if (value.length > 10) {
        callback(new Error("角色名称最多10个字"));
      }
      callback();
    };
    return {
      ruleForm: {
        name: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
          { validator: validateName, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    close(result) {
      this.config.show = false;
      if (result) this.$emit("close");
    },
    onSubmit() {
      let _this = this;
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.config.data.id) {
            await this.$promission.post("/api/Roles/Update", _this.config.data);
            _this.$message({
              showClose: true,
              type: "success",
              message: "角色修改成功!",
            });
          } else {
            await this.$promission.post("/api/Roles/Create", _this.config.data);
            _this.$message({
              showClose: true,
              type: "success",
              message: "角色创建成功!",
            });
          }
          this.close(true);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog_publish_main {
  padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/RoleNameEduit.vue